
export default function WhyChooseUsSection() {
  const benefits = [
    {
      icon: 'ri-search-line',
      title: 'Brokerage Model',
      description: 'We shop lenders for you, saving time and money by comparing multiple options to find the best rates and terms for your specific situation.',
      highlight: 'Save Time & Money'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'No Hard Inquiry',
      description: 'Our pre-approval process protects your credit score with no hard inquiries, allowing you to explore options without impact.',
      highlight: 'Credit Protected'
    },
    {
      icon: 'ri-stack-line',
      title: 'Wide Range of Products',
      description: 'Access to diverse real estate-focused loan products from fix & flip to commercial real estate, all under one roof.',
      highlight: '8+ Loan Types'
    },
    {
      icon: 'ri-eye-line',
      title: 'Transparent & Compliant',
      description: 'We maintain a compliance-first approach with complete transparency. No misleading guarantees or hidden fees.',
      highlight: 'Full Transparency'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Advisory Support',
      description: 'Our expert team provides strategic guidance to position your business for maximum funding approvals and success.',
      highlight: 'Expert Guidance'
    },
    {
      icon: 'ri-timer-flash-line',
      title: 'Fast Processing',
      description: 'Streamlined application process with quick pre-approvals, typically within 24-48 hours for most loan products.',
      highlight: '24-48 Hour Response'
    }
  ];

  return (
    <section id="why-choose-us" className="py-20 bg-gradient-to-br from-blue-50 to-indigo-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Why Choose Fast Funding Capital
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            As a commercial real estate brokerage firm, we bring unique advantages that set us apart from direct lenders and other financing options.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 relative overflow-hidden group">
              <div className="absolute top-0 right-0 bg-blue-600 text-white px-3 py-1 rounded-bl-lg text-sm font-semibold">
                {benefit.highlight}
              </div>
              
              <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors duration-300">
                <i className={`${benefit.icon} text-2xl text-blue-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {benefit.title}
              </h3>
              
              <p className="text-gray-600 leading-relaxed">
                {benefit.description}
              </p>
              
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-blue-600 to-indigo-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white rounded-2xl shadow-lg p-8 max-w-4xl mx-auto">
            <div className="flex items-center justify-center mb-6">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
                <i className="ri-award-line text-3xl text-green-600"></i>
              </div>
            </div>
            <h3 className="text-3xl font-bold text-gray-900 mb-4">
              Licensed Real Estate Broker
            </h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              As a licensed commercial real estate brokerage firm, we operate with the highest standards of professionalism, ethics, and regulatory compliance. Your success is our success.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <div className="flex items-center bg-gray-50 rounded-lg px-4 py-2">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-check-double-line text-green-600"></i>
                </div>
                <span className="text-gray-700 font-medium">Licensed & Bonded</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded-lg px-4 py-2">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-shield-check-line text-green-600"></i>
                </div>
                <span className="text-gray-700 font-medium">Regulatory Compliant</span>
              </div>
              <div className="flex items-center bg-gray-50 rounded-lg px-4 py-2">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-user-heart-line text-green-600"></i>
                </div>
                <span className="text-gray-700 font-medium">Client-First Approach</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
